import { useCallback } from 'react';
import qs from 'query-string';
import { collectorUninstall, isWithinAnotherApp } from 'containerApp';
import { CollectorScope, Collector } from 'graphql/types';

type UseOnDisconnectProps = {
  onClose: () => void;
  scope: CollectorScope;
};

export const useHandleDisconnect = ({
  onClose,
  scope
}: UseOnDisconnectProps): ((collector: Collector) => () => void) => {
  const handleDisconnect = useCallback(
    (collector: Collector) => {
      const query = qs.stringify({
        id: collector.id,
        scope: scope
      });
      const { origin } = window.location;
      const url = `${origin}/collector/uninstall?${query}`;
      if (isWithinAnotherApp()) {
        collectorUninstall(url);
      } else {
        window.open(`/collector/uninstall?${query}`);
      }
      onClose();
    },
    [onClose, scope]
  );

  const onDisconnect = useCallback(
    (collectorItem) => () => handleDisconnect(collectorItem),
    [handleDisconnect]
  );

  return onDisconnect;
};
